import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Flex, Box, Hide } from '@elparking/components'

import Warning from 'parking-availability/js/ui/Warning'
import AvailabilityErrorMessage from 'parking-availability/js/components/AvailabilityErrorMessage'
import BookingProduct from 'parking-availability/js/components/BookingProduct'
import BookingProductsModal from 'parking-availability/js/components/BookingProductsModal'

import { LOCALE_DATETIME_FORMAT, STATUS_AVAILABLE, STATUS_UNAVAILABLE } from 'commons/js/constants'

import { BookingProductType } from 'parking-availability/js/propTypes'

import PriceButton from './PriceButton'
import CancelationInfo from './CancelationInfo'

function getFormError (errors) {
    return errors.find(({ field }) => !field)
}

function getAvailabilityError (bookingProducts) {
    const areAnyProductAvailable = bookingProducts.some(({ availability }) =>
        availability.availabilityStatus === STATUS_AVAILABLE)

    if (!areAnyProductAvailable) {
        return {
            status: STATUS_UNAVAILABLE,
            data: null,
        }
    }

    return null
}

const hasErrors = ({ errors, bookingProducts }) => !!getFormError(errors) || !!getAvailabilityError(bookingProducts)

class MultiProductForm extends PureComponent {
    static propTypes = {
        selectedBookingProduct: BookingProductType,
        bookingProducts: PropTypes.arrayOf(BookingProductType).isRequired,
        errors: PropTypes.arrayOf(PropTypes.shape({
            field: PropTypes.string,
            message: PropTypes.string,
        })),
        isLoading: PropTypes.bool,
        onSubmit: PropTypes.func,
        hasDates: PropTypes.bool,
    }

    static defaultProps = {
        format: LOCALE_DATETIME_FORMAT,
        isLoading: false,
        hasDates: false,
        errors: [],
        onSubmit: () => {},
    }

    state = {
        isModalOpen: false,
    }

    onSubmit = this.onSubmit.bind(this)

    onSubmit (event) {
        event.preventDefault()

        this.showBookingProductsModal()
    }

    onConfirm = this.onConfirm.bind(this)

    onConfirm (bookingProduct) {
        this.hideBookingProductsModal()
        this.props.onSubmit(bookingProduct)
    }

    showBookingProductsModal = this.showBookingProductsModal.bind(this)

    showBookingProductsModal () {
        this.setState(() => ({
            isModalOpen: true,
        }))
    }

    hideBookingProductsModal = this.hideBookingProductsModal.bind(this)

    hideBookingProductsModal () {
        this.setState(() => ({
            isModalOpen: false,
        }))
    }

    renderBookingProduct () {
        const { selectedBookingProduct } = this.props

        return (
            <BookingProduct bookingProduct={selectedBookingProduct} isDisabled />
        )
    }

    renderError () {
        const { errors, bookingProducts } = this.props

        const error = getFormError(errors)
        const availabilityError = getAvailabilityError(bookingProducts)

        if (error) {
            return (
                <Warning>{error.message}</Warning>
            )
        }

        if (availabilityError) {
            return (
                <Warning>
                    <AvailabilityErrorMessage error={availabilityError} />
                </Warning>
            )
        }

        return null
    }

    renderSubmitButton () {
        const { isLoading, hasDates } = this.props
        const isDisabled = !hasDates || hasErrors(this.props)

        return (
            <PriceButton
              isLoading={isLoading}
              isDisabled={isDisabled}
            />
        )
    }

    renderCancelationInfo () {
        return (
            <CancelationInfo />
        )
    }

    render () {
        const { bookingProducts, selectedBookingProduct } = this.props

        return (
            <Flex as='form' flexWrap='wrap' alignItems='stretch' onSubmit={this.onSubmit} noValidate>
                {selectedBookingProduct && <Box flex='1 0 100%' mb='1em' style={{ minWidth: 0 }}>
                    {this.renderBookingProduct()}
                </Box>}
                {hasErrors(this.props) && <Box flex='1 0 100%' mb='1em'>
                    {this.renderError()}
                </Box>}
                <Box flex='1 0 100%' mb='1em'>
                    {this.renderSubmitButton()}
                </Box>
                <Hide xs sm md>
                    <Box flex='1 0 100%'>
                        {this.renderCancelationInfo()}
                    </Box>
                </Hide>
                <BookingProductsModal
                  isOpen={this.state.isModalOpen}
                  onClose={this.hideBookingProductsModal}
                  onSubmit={this.onConfirm}
                  selectedBookingProduct={selectedBookingProduct}
                  bookingProducts={bookingProducts}
                />
            </Flex>
        )
    }
}

export default MultiProductForm
